import { createRoot } from "react-dom/client";
import { initI18n } from "./i18n";
import { App, AppStage } from "./App";
import { Language } from "./common";

const appElem = document.getElementById("app") as HTMLElement;
const language = appElem.getAttribute("data-language") ?? "fi";
const returnUrl = appElem.getAttribute("data-return-url") ?? "/yritykset";
const stage = appElem.getAttribute("data-stage") as AppStage;
initI18n(language.toLowerCase() as Language).then(() => {
	const root = createRoot(appElem);
	root.render(<App returnUrl={returnUrl} stage={stage} />);
}).catch((err: unknown) => console.log(err));
